import { useLocation, useNavigate } from 'react-router-dom';

export default function PaymentFailed() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
      padding: '20px',
      fontFamily: '"Inter", sans-serif'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '40px 30px',
        width: '100%',
        maxWidth: '450px',
        border: '1px solid rgba(255, 0, 100, 0.2)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        textAlign: 'center'
      }}>
        {/* Warning icon */}
        <div style={{
          marginBottom: '30px',
          color: '#ff4d6d'
        }}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#ff4d6d" strokeWidth="2"/>
            <path d="M12 8V12" stroke="#ff4d6d" strokeWidth="2" strokeLinecap="round"/>
            <path d="M12 16H12.01" stroke="#ff4d6d" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        
        {/* Error message */}
        <h1 style={{
          color: '#fff',
          fontSize: '28px',
          fontWeight: '700',
          marginBottom: '10px'
        }}>Payment Failed</h1>
        
        <p style={{
          color: 'rgba(255, 255, 255, 0.7)',
          fontSize: '16px',
          marginBottom: '30px'
        }}>We couldn't process your payment</p>
        
        {/* Error details */}
        {/* <div style={{
          background: 'rgba(255, 77, 109, 0.1)',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '30px',
          border: '1px solid rgba(255, 77, 109, 0.2)'
        }}>
          {state?.error && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              marginBottom: '15px'
            }}>
              <span style={{ color: 'rgba(255, 255, 255, 0.7)', alignSelf: 'flex-start' }}>Reason:</span>
              <span style={{ 
                color: '#ff4d6d',
                fontWeight: '500',
                wordBreak: 'break-word',
                textAlign: 'left'
              }}>
                {state.error}
              </span>
            </div>
          )}

          {state?.amount && (
            <div style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <span style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Amount:</span>
              <span style={{ color: '#fff', fontWeight: '600' }}>
                {state.amount} {state.currency}
              </span>
            </div>
          )}
        </div> */}
        
        {/* Action buttons */}
        <div style={{
          display: 'flex',
          gap: '15px'
        }}>
          <button 
            onClick={() => navigate('/token/rzto')}
            style={{
              background: 'linear-gradient(90deg, #ff4d6d 0%, #ff758f 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              padding: '14px 24px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              flex: 1,
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.opacity = '0.9'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            Try Again
          </button>
          
          <button 
            onClick={() => navigate('/')}
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#fff',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '12px',
              padding: '14px 24px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              flex: 1,
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
            onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
          >
            Return Home
          </button>
        </div>
      </div>
    </div>
  );
}